import { setOpenModalOutOfCredits, setOpenModalTryPremium } from '@/store/slices/user/actions'

const OUT_OF_CREDITS_UPGRADE_SOURCE = 'BtSubscriptionOutOfCredits'

interface OutOfCreditsModalConfig {
  key: 'AI_LIMIT' | 'AI_LIMIT_SUPER'
  onPrimary: () => void
  onSecondary: () => void
}

export function createOutOfCreditsModalConfig({
  dispatch,
  userIsSuper,
  pendingCallback,
}: {
  dispatch: (action: unknown) => void
  userIsSuper: boolean
  pendingCallback?: Function | null
}): OutOfCreditsModalConfig {
  const closeOutOfCreditsModal = () => {
    dispatch(setOpenModalOutOfCredits({ isOpen: false, callback: null, upgradeInitiated: false }))
  }

  if (userIsSuper) {
    return {
      key: 'AI_LIMIT_SUPER',
      onPrimary: closeOutOfCreditsModal,
      onSecondary: closeOutOfCreditsModal,
    }
  }

  return {
    key: 'AI_LIMIT',
    onPrimary: () => {
      dispatch(setOpenModalOutOfCredits({ isOpen: false, callback: null, upgradeInitiated: true }))
      dispatch(setOpenModalTryPremium({ isOpen: true, source: OUT_OF_CREDITS_UPGRADE_SOURCE, callback: pendingCallback ?? undefined }))
    },
    onSecondary: closeOutOfCreditsModal,
  }
}
